import type { ComponentType } from "react";

import {
  BadgeCheck,
  BookOpen,
  LayoutDashboard,
  Megaphone,
  ScrollText,
  Users,
  UsersRound,
} from "lucide-react";

import { Permission } from "@/store/apis/adminApi.types";

export interface NavItem {
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
  /** Permisos autorizados (cualquiera de ellos). `undefined` = todos. */
  allow?: readonly Permission[];
}

/**
 * Config central del side nav. Agregar una feature nueva = agregar una
 * entrada acá. El `PermissionGuard` del layout se encarga del filtrado
 * visual; el backend siempre valida además.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { label: "Inicio", to: "/", icon: LayoutDashboard, allow: [Permission.DashboardRead] },
  { label: "Consejos", to: "/consejos", icon: BookOpen, allow: [Permission.AdviceRead] },
  { label: "Pop-ups", to: "/popups", icon: Megaphone, allow: [Permission.PopupsRead] },
  { label: "Círculo", to: "/circulo/grupos", icon: UsersRound, allow: [Permission.CircleRead] },
  { label: "Admins", to: "/admins", icon: Users, allow: [Permission.AdminsManage] },
  { label: "Auditoría", to: "/auditoria", icon: ScrollText, allow: [Permission.AuditRead] },
  { label: "Mi cuenta", to: "/perfil", icon: BadgeCheck },
] as const;
